export enum TableActions {
    Add = "Add",
    Edit = "Edit",
    Delete = "Delete"
}
